export default __webpack_public_path__ + "ebb4af0298f08ba707a9b3e16604b44e.png";